export const environment = {
  production: false,
  apiUrl: '/dev-api', // <-- ajusta esta URL al servidor dev
  bruteForce: {
    maxAttempts: 5,
    lockoutDuration: 15 * 60 * 1000, // 15 minutos
  }
};
